import moment from 'moment';

export const userContentStatus = (content, performance, assignInfo) => {
  if (!performance) return 'UNASSIGNED';
  if (
    (!content.contributeToSuccessStatus && performance.completionStatus === 'COMPLETE')
    || (content.contributeToSuccessStatus
      && performance.completionStatus === 'COMPLETE'
      && performance.successStatus === 'PASS')
  ) {
    return 'COMPLETE';
  }
  if (
    content.contributeToSuccessStatus
    && performance.completionStatus === 'COMPLETE'
    && performance.successStatus === 'NA'
  ) {
    return 'AWAITING';
  }
  if (assignInfo && assignInfo.dueDate && assignInfo.dueDate !== '-1') {
    if (moment(assignInfo.dueDate).isBefore(moment())) {
      return 'OVERDUE';
    }
  }
  return 'IN_PROGRESS';
};
